import {WidgetApi} from "@/api/widgetApi";

const TABLE_COLUMN_WIDTH_OFFSET = 2
const TABLE_COLUMN_HEADER_WIDTH_MULT = 2
const TABLE_RENDER_WAIT_TIME = 20
const COL_MIN_WIDTH = 100
const COL_MAX_WIDTH = 600
const LOCK_CLASS_NAME = 'dummy-table'
const CELL_CLASS = 'cell'
const COLUMN_TAG = 'col'

export default {
    data () {
        return {
            uid: 0,
            finalCellsContentWidth: [],
            tableElements: {
                elTable: null,
                header: {
                    type: 'thead',
                    cellType: 'th',
                    wrapper: null,
                    table: null,
                    colGroup: null,
                    colGroupsWidth: [],
                    tableContent: null,
                    contentWidth: [],
                    contentWidthOrigin: []
                },
                body: {
                    type: 'tbody',
                    cellType: 'td',
                    wrapper: null,
                    table: null,
                    colGroup: null,
                    colGroupsWidth: [],
                    tableContent: null,
                    contentWidth: [],
                    contentWidthOrigin: [],
                    rowsNum: 0
                },
                finalContentWidth: []
            },
            dummyTableElements: {
                elTable: null,
                headerContent: null,
                bodyContent: null
            },
        }
    },
    methods: {
        initTableParams (params) {
            params.colGroupsWidth = []
            const tableChildren = [...params.table.children]

            const tableColgroup = tableChildren.find(el => el.tagName.toLowerCase() === 'colgroup')
            params.colGroup = tableColgroup
            params.tableContent = tableChildren.find(el => {
                return el.tagName.toLowerCase() === params.type
            })

            const tableColgroupChildren = [...tableColgroup.children]
            const tableColgroupCols = tableColgroupChildren.filter(el => el.tagName
                .toLowerCase() === COLUMN_TAG)
            tableColgroupCols.forEach(el => params.colGroupsWidth.push(Number(el.width) || COL_MIN_WIDTH))

        },
        getMaxColumnContentWidth (params, index) {
            const content = params.tableContent
            const rows = [...content.children].filter(el => el.tagName.toLowerCase() === 'tr')
            if (params.type === 'tbody') {
                params.rowsNum = rows.length
            }
            const tableCells = []
            rows.forEach(row => {
                const cells = [...row.children].filter(el => el.tagName.toLowerCase() === params.cellType)
                tableCells.push(cells[index])
            })


            tableCells.map(cell => {
                const cellContent = ([...cell.children].find(el => el.className.includes(CELL_CLASS)))

                const contentWidth = (cellContent.getBoundingClientRect()).width
                params.contentWidth[index] = contentWidth > params.contentWidth[index] ? contentWidth : params.contentWidth[index]
            })
        },
        setContentWidthLimits () {
            this.tableElements.header.contentWidthOrigin = [...this.tableElements.header.contentWidth]
            this.tableElements.header.contentWidth = this.tableElements.header.contentWidth.map(value => {
                const fixedValue = value + TABLE_COLUMN_WIDTH_OFFSET
                if (fixedValue < COL_MIN_WIDTH) {
                    return COL_MIN_WIDTH
                }
                if (fixedValue > COL_MAX_WIDTH) {
                    return COL_MAX_WIDTH
                }
                return fixedValue
            })
            this.tableElements.body.contentWidthOrigin = [...this.tableElements.body.contentWidth]
            this.tableElements.body.contentWidth = this.tableElements.body.contentWidth.map(value => {
                const fixedValue = value + TABLE_COLUMN_WIDTH_OFFSET
                if (fixedValue < COL_MIN_WIDTH) {
                    return COL_MIN_WIDTH
                }
                if (fixedValue > COL_MAX_WIDTH) {
                    return COL_MAX_WIDTH
                }
                return fixedValue
            })
        },
        initMaxColumnsContentWidth () {
            this.tableElements.header.colGroupsWidth.map( async (el, index) => {
                await this.getMaxColumnContentWidth(this.tableElements.header, index)
                await this.getMaxColumnContentWidth(this.tableElements.body, index)
            })
        },
        setColumnsToMaxWidth () {
            if (this.tableElements.header.colGroup) {
                const tableColgroupChildren = [...this.tableElements.header.colGroup.children]
                const tableColgroupCols = tableColgroupChildren.filter(el => el.tagName
                    .toLowerCase() === COLUMN_TAG)
                tableColgroupCols.forEach(el => {
                    el.width = '' + COL_MAX_WIDTH
                })
            }
            if (this.tableElements.body.colGroup) {
                const tableColgroupChildren = [...this.tableElements.body.colGroup.children]
                const tableColgroupCols = tableColgroupChildren.filter(el => el.tagName
                    .toLowerCase() === COLUMN_TAG)
                tableColgroupCols.forEach(el => {
                    el.width = '' + COL_MAX_WIDTH
                })
            }
            this.tableElements.body.table.style.width = this.tableElements.body.colGroup.length * COL_MAX_WIDTH + 'px'
        },
        calculateFinalContentWidth () {
            this.setContentWidthLimits()
            this.tableElements.finalContentWidth = this.tableElements.header.contentWidth.map((hValue, index) => {
                const bValue = this.tableElements.body.contentWidth[index]
                return Math.ceil(bValue)
            })
        },
        async init () {
            await new Promise(resolve => setTimeout(resolve, 100))

            const table = this.$refs['table']
            const elTable = table.$el.cloneNode(true)
            const tableId = elTable.getAttribute('id')
            elTable.setAttribute('id', `custom_${tableId}`)

            this.tableElements.elTable = elTable

            if (!elTable.className.includes(LOCK_CLASS_NAME)) {
                elTable.className += ` ${LOCK_CLASS_NAME}`
            }
            table.$el.parentElement.appendChild(elTable)

            const elTableChildren = [...elTable.children]
            const elTableHeaderWrapper = elTableChildren.find(el => el.className.includes('el-table__header-wrapper'))
            const elTableBodyWrapper = elTableChildren.find(el => el.className.includes('el-table__body-wrapper'))
            this.tableElements.header.wrapper = elTableHeaderWrapper
            this.tableElements.body.wrapper = elTableBodyWrapper

            const elTableHeaderWrapperChildren = [...elTableHeaderWrapper.children]
            this.tableElements.header.table = elTableHeaderWrapperChildren.find(el => el.className.includes('el-table__header'))

            const elTableBodyWrapperChildren = [...elTableBodyWrapper.children]
            this.tableElements.body.table = elTableBodyWrapperChildren.find(el => el.className.includes('el-table__body'))

            this.initTableParams(this.tableElements.header)
            this.initTableParams(this.tableElements.body)

            const tableColsNum = this.tableElements.header.colGroupsWidth.length || this.tableElements.body.colGroupsWidth.length

            this.tableElements.header.contentWidth = new Array(tableColsNum).fill(0)
            this.tableElements.body.contentWidth = new Array(tableColsNum).fill(0)

            this.setColumnsToMaxWidth()

            // wait for table rendering after table width changed
            await new Promise(resolve => setTimeout(resolve, TABLE_RENDER_WAIT_TIME))

            await this.initMaxColumnsContentWidth()
            this.calculateFinalContentWidth()

            elTable.remove()

            const isColumnPropertyEmpty = !this.columnsProperty.length
            this.tableElements.finalContentWidth.forEach((el, index) => {
                this.widget.WidgetLayout.columnsProperty[index].width = el
                if (this.columnsProperty) {
                    if (isColumnPropertyEmpty) {
                        this.columnsProperty[index] = this.widget.WidgetLayout.columnsProperty[index]
                    } else {
                        this.columnsProperty[index].width = el
                    }
                }
            })
            this.widget.WidgetLayout.isCalcColumnsWidth = true

            if (this.widget.WidgetLayout.columnsProperty) {
                this.widget.WidgetLayout.columnsProperty.forEach(col => {
                    const column = this.availableColumns.find(c => c.prop === col.columnKey)
                    if (column) {
                        column.minWidth = col.width
                    }
                })
            }

            try {
                await WidgetApi.update(this.widget)
            } catch (e) {
                console.error(e)
            } finally {
                const event = new CustomEvent('endTableColumnsWidthAutoAdjust', {
                    detail: {
                        uid: this.uid
                    }
                })
                document.dispatchEvent(event)
            }

        }
    },
    async created () {
        this.uid = `${this._uid}_${Math.round(Math.random() * 1000000)}`
    },
    mounted() {
        const _this = this
        document.addEventListener('startTableColumnsWidthAutoAdjust', function (e) {
            if (_this.uid === e.detail.uid) {
                _this.init()
            }
        })
        if (!this.widget.WidgetLayout.isCalcColumnsWidth) {
            const event = new CustomEvent('registerTableColumnsWidthAutoAdjust', {
                detail: {
                    uid: this.uid
                }
            })
            document.dispatchEvent(event)
        }
    }
}
